import { useApiTradeV1SiteMaterialsRetrieveSuspense } from '../../client/api/api';
import type { AllowedMaterialSpecInfoAiModel } from '../../schemas';

export const useMaterialModel = (siteMaterialId: string, raiseError = true): AllowedMaterialSpecInfoAiModel => {
  const { data: siteMaterial } = useApiTradeV1SiteMaterialsRetrieveSuspense(siteMaterialId);
  const model = siteMaterial?.material_spec.ai_model;

  if (model === null && raiseError) {
    throw new Error('No AI product exists for this material type.');
  }

  return model;
};
